import { t } from '@web/i18n';
import { AppIcons, FilterSelect, Input } from '@web/ui/core';

import { type RoleFilter, type SortMode, type StatusFilter } from '@web/ui/members/hooks';

interface MembersToolbarProps {
  query: string;
  setQuery: (v: string) => void;
  domain: string;
  setDomain: (v: string) => void;
  role: RoleFilter;
  setRole: (v: RoleFilter) => void;
  status: StatusFilter;
  setStatus: (v: StatusFilter) => void;
  sort: SortMode;
  setSort: (v: SortMode) => void;
  allDomains: string[];
}

export function MembersToolbar(props: Readonly<MembersToolbarProps>): React.JSX.Element {
  const {
    query,
    setQuery,
    domain,
    setDomain,
    role,
    setRole,
    status,
    setStatus,
    sort,
    setSort,
    allDomains,
  } = props;

  return (
    <div className="mb-3 flex items-center gap-2">
      <div className="flex max-w-search-md flex-1">
        <Input
          size="sm"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
          placeholder={t('members.toolbar.searchPlaceholder')}
          leadingIcon={<AppIcons name="magnifying-glass" size={14} />}
        />
      </div>

      <FilterSelect
        label={t('members.toolbar.filter.domain')}
        icon="globe"
        value={domain}
        setValue={setDomain}
        options={[
          { value: 'all', label: t('members.toolbar.filter.all') },
          ...allDomains.map((d) => ({ value: d, label: d })),
        ]}
        mono
      />

      <FilterSelect
        label={t('members.toolbar.filter.role')}
        icon="shield-check"
        value={role}
        setValue={setRole}
        options={[
          { value: 'all', label: t('members.toolbar.filter.all') },
          { value: 'guest', label: t('members.role.guest') },
          { value: 'member', label: t('members.role.member') },
          { value: 'admin', label: t('members.role.admin') },
        ]}
      />

      <FilterSelect
        label={t('members.toolbar.filter.status')}
        icon="circle-half"
        value={status}
        setValue={setStatus}
        options={[
          { value: 'all', label: t('members.toolbar.filter.all') },
          { value: 'active', label: t('members.status.active') },
          { value: 'inactive', label: t('members.status.inactive') },
          { value: 'suspended', label: t('members.status.suspended') },
        ]}
      />

      <div className="ml-auto">
        <FilterSelect
          label={t('members.toolbar.filter.sort')}
          icon="sort-ascending"
          value={sort}
          setValue={setSort}
          options={[
            { value: 'recent', label: t('members.toolbar.sort.recent') },
            { value: 'oldest', label: t('members.toolbar.sort.oldest') },
            { value: 'name', label: t('members.toolbar.sort.name') },
            { value: 'activity', label: t('members.toolbar.sort.activity') },
          ]}
        />
      </div>
    </div>
  );
}
